module.exports = __webpack_public_path__ + "img/user-empty.2d4ef2b1.png";